<style lang="less" scoped>
  @import "../../vars.less";

  .btn-container {
    padding: @space-normal;
  }
</style>

<template>
  <page-container class="change-password" :loading="loading">
    <van-form @submit="onSubmit">
      <van-field
        v-model="oldPassword"
        name="oldPassword"
        :label="$t('旧密码')"
        :placeholder="$t('请输入密码')"
        :type="!showOldPwd ? 'password' : 'text'"
        :right-icon="showOldPwd ? 'eye-o' : 'closed-eye'"
        @click-right-icon="() => showOldPwd = !showOldPwd"
      />
      <van-field
        v-model="firstPassword"
        name="firstPassword"
        :label="$t('新密码')"
        :placeholder="$t('请输入新密码')"
        :type="!showNewPwd ? 'password' : 'text'"
        :right-icon="showNewPwd ? 'eye-o' : 'closed-eye'"
        @click-right-icon="() => showNewPwd = !showNewPwd"
      />
      <van-field
        v-model="secondPassword"
        name="secondPassword"
        :label="$t('新密码')"
        :placeholder="$t('请再次输入新密码')"
        :type="!showNewPwd ? 'password' : 'text'"
        :right-icon="showNewPwd ? 'eye-o' : 'closed-eye'"
        @click-right-icon="() => showNewPwd = !showNewPwd"
      />
      <div class="btn-container">
        <van-button round block type="info" size="small"
          native-type="submit" :disabled="!canSubmit">{{ $t('提交') }}</van-button>
      </div>
    </van-form>
  </page-container>
</template>

<script>
import { Button, Field, Form, Toast, Notify } from 'vant'
import PageContainer from '../../components/PageContainer'
import isValidPassword from '../../utils/valid-password'
import ls from '../../utils/local-storage'

export default {
  components: {
    PageContainer,
    'van-button': Button,
    'van-field': Field,
    'van-form': Form
  },
  name: 'change-pasword',
  data () {
    return {
      loading: false,
      showOldPwd: false,
      showNewPwd: false,
      firstPassword: '',
      secondPassword: '',
      oldPassword: ''
    }
  },
  computed: {
    canSubmit () {
      return !!(this.firstPassword.trim() &&
        this.secondPassword.trim() &&
        this.oldPassword.trim())
    }
  },
  methods: {
    onSubmit (values) {
      if (values.firstPassword !== values.secondPassword) {
        Toast({
          message: this.$t('两次输入的密码不一致'),
          duration: 3000
        })
        return
      }

      if (!isValidPassword(values.firstPassword)) {
        Toast({
          message: this.$t('密码最少10个字符，且必须包含数字、大小写字母和特殊字符中的任意三种'),
          duration: 5000
        })
        return
      }

      this.$apis.profile.changePassword(
        values,
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          Notify({
            message: this.$t('密码修改成功，请重新登录'),
            type: 'success'
          })
          ls.clear()
          this.$router.push({ name: 'login' })
        }
      })
    }
  }
}
</script>
